// Author Lidongxu
// Date 2025-07-01 13:41:51

class EmEpcTagMaterial {
constructor({
        id = null,
        remark = '',
        tagMaterialName = '',
        tagMaterialType = '',
        tagSize = '',
        isAntiMetal = '',
        isReusable = ''}
= {}) {
    this.id = id;
    this.remark = remark;
    this.tagMaterialName = tagMaterialName;
    this.tagMaterialType = tagMaterialType;
    this.tagSize = tagSize;
    this.isAntiMetal = isAntiMetal;
    this.isReusable = isReusable;
}
}

function newEntity() {
return new EmEpcTagMaterial();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.epc.emEpcTagMaterial.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.em.epc.emEpcTagMaterial.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'tagMaterialName',
        label: 'label.em.epc.emEpcTagMaterial.grid.tagMaterialName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'tagMaterialType',
        label: 'label.em.epc.emEpcTagMaterial.grid.tagMaterialType',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '0', text: '柔性' },
                            { value: '1', text: '硬质' }
            ]
                }
        },
        {
        key: 'tagSize',
        label: 'label.em.epc.emEpcTagMaterial.grid.tagSize',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'isAntiMetal',
        label: 'label.em.epc.emEpcTagMaterial.grid.isAntiMetal',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'isReusable',
        label: 'label.em.epc.emEpcTagMaterial.grid.isReusable',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    tagMaterialNameFilter : '',
    tagMaterialTypeFilter : '',
    tagSizeFilter : '',
    isAntiMetalFilter : '',
    isReusableFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'tagMaterialNameFilter',
        label: 'label.em.epc.emEpcTagMaterial.filter.tagMaterialName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tagMaterialTypeFilter',
        label: 'label.em.epc.emEpcTagMaterial.filter.tagMaterialType',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '0', text: '柔性' },
                { value: '1', text: '硬质' }
            ]
        }
        },
        {
        key: 'tagSizeFilter',
        label: 'label.em.epc.emEpcTagMaterial.filter.tagSize',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'isAntiMetalFilter',
        label: 'label.em.epc.emEpcTagMaterial.filter.isAntiMetal',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'isReusableFilter',
        label: 'label.em.epc.emEpcTagMaterial.filter.isReusable',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'remark',
        label: 'label.em.epc.emEpcTagMaterial.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tagMaterialName',
        label: 'label.em.epc.emEpcTagMaterial.entity.tagMaterialName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tagMaterialType',
        label: 'label.em.epc.emEpcTagMaterial.entity.tagMaterialType',
        sortable: true,
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
        ,options: [
                { value: '0', text: '柔性' },
                { value: '1', text: '硬质' }
            ]
        }
        },
        {
        key: 'tagSize',
        label: 'label.em.epc.emEpcTagMaterial.entity.tagSize',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'isAntiMetal',
        label: 'label.em.epc.emEpcTagMaterial.entity.isAntiMetal',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'isReusable',
        label: 'label.em.epc.emEpcTagMaterial.entity.isReusable',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        }
]

export {EmEpcTagMaterial, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
